import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AppUtils } from 'src/app/helpers/app.utils';
import { PageUrls } from 'src/app/helpers/page-urls';
import { TableModel } from 'src/app/models/table.model';
import { ZohoBookBillDtoModel } from 'src/app/photographer/models/zoho.book.bill.model';
import { ZohoBookService } from 'src/app/photographer/services/zoho.book.service';

@Component({
    selector: 'app-zoho-book-detail',
    templateUrl: './zoho.book.detail.component.html'
})
export class ZohoBookDetailComponent implements OnInit {

    totalRecords = 0;
    model = new ZohoBookBillDtoModel();
    subscriptions = new Array<Subscription>();
    tableModel = new TableModel();
    isModelLoaded = false;

    id: number;

    get urls() {
        return PageUrls;
    }

    constructor(private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        private zohoBookService: ZohoBookService,
        private route: ActivatedRoute) {
        this.tableModel.orderBy = 'Name';
        this.tableModel.orderByDirection = 'asc';
    }

    ngOnInit() {
        this.id = this.route.snapshot.queryParams.id;
        this.initSubscribers();
        this.getZohoBookBillDetail();
    }

    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getZohoBookBillDetail());
        this.subscriptions.push(subscription);
    }

    getZohoBookBillDetail() {
        this.spinner.show();
        this.zohoBookService.details(this.tableModel, this.id).subscribe(
            data => {
                Object.assign(this.model, data);
                this.totalRecords = this.model.pagedBillLineItems.totalCount;
                this.model.pagedBillLineItems.items.forEach(bill => {
                    const prefix = bill.size === 3 ? 'LG-' : bill.size === 2 ? 'MD-' : 'SM-';
                    bill.description = `${prefix}${bill.localId}-${bill.name}`;
                });

                this.spinner.hide();
                this.isModelLoaded = true;
            },
            error => {
                this.spinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    exportAsPdf() {
        this.spinner.show();
        this.zohoBookService.exportAsPdf(this.id).subscribe(
            fileBytes => {
                const blob: any = new Blob([fileBytes], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const element = document.createElement('a');
                element.href = url;
                element.download = `${this.model.billNumber}`;
                document.body.appendChild(element);
                this.spinner.hide();
                element.click();
            },
            error => {
                this.spinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }
}
